import classNames from "classnames";

import css from "./calendar_date.module.scss";

export const getDayClass = (config, ...classes) =>
  classNames(
    css.day,
    {
      [css.today]: config.today,
      [css.prevBusy]: config.prevBusy,
      [css.nextBusy]: config.nextBusy,
      [css.nonWorking]: config.nonWorking,
      [css.pending]: config.pending,
      [css.partial]: config.partial,
      [css.hovered]: config.hovered,
      [css.disabled]: config.disabled,
      [css.selected]: config.selected,
      [css.keyboardSelected]: config.keyboardSelected,
      [css.readOnly]: config.readOnly,
      [css.notCurrentMonth]: config.notCurrentMonth,
      [css.hardKind]: config.hardKind,
      [css.softKind]: config.softKind,
      [css.otherKind]: config.otherKind,
      [css.freeKind]: config.freeKind,
      [css.offLimit]: config.offLimit,
      [css.plannedKind]: config.plannedKind,
      [css.noneKind]: config.noneKind // just for the legend
    },
    ...classes
  );
